<template>
  <pt-points-grant-form class="pt-points-grant-form__page"></pt-points-grant-form>
</template>

<script>
import PtPointsGrantForm from 'cps/new-to-old-audit/pt-points-reward/pt-points-grant-form'
export default {
  name: 'pt-points-grant-form__view',
  components: {
    'pt-points-grant-form': PtPointsGrantForm
  }
}
</script>
